import React from "react";
import styles from "./BulkEditForm.module.css";

import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { Form } from "@progress/kendo-react-form";
import { Button} from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import UserList from "./UserList";
import EditFields from "./EditFields";


/*
  Todo:
    - change skills/queues/... edit + in separate component(s) -> how to put in multiple columns (+flexible number of columns) ?
*/


const EmptyButton = props => {};

const BulkEditForm = props => {
    const {
      cancelEdit,
      onSubmit,
      onSelectedDataRemoved,
//      onAdditionalFieldSelected,
      fields,
      rows,
      selectedData,
      editFieldsTitle,
      inputFieldTitle,
      addFieldTitle,
      ...other
    } = props;

    return <Form
                onSubmit={onSubmit} 
                render={renderProps => 

            <Window title={props.title} 
                    onClose={cancelEdit}
                    resizable={false}
                    modal={true}
                    draggable={false}
                    maximizeButton={EmptyButton}
                    minimizeButton={EmptyButton}
                    initialHeight={0.9 * window.innerHeight}
                    initialWidth={0.9 * window.innerWidth}
                    height={0.9 * window.innerHeight}
                    width={0.9 * window.innerWidth}
            >
              <GridLayout
               gap={{
                rows: 5,
                cols: 5,
              }}
              align={{
                horizontal: "stretch"
              }}
                cols={[
                  {
                    width: 0.85 * window.innerWidth,
                  },]}
              >
                <GridLayoutItem row={1} col={1}>
                  <UserList
                    title={"Users"}
                    data={selectedData}
                    onDataRemoved={onSelectedDataRemoved}
                  />
                </GridLayoutItem>
                <GridLayoutItem row={2} col={1} >
                  <EditFields
                    title={editFieldsTitle}
                    inputFieldTitle={inputFieldTitle}
                    addFieldTitle={addFieldTitle}
                    data={fields}
                    removable={props.removeEnabled}
//                    onAdditionalFieldSelected={onAdditionalFieldSelected}
                  />
                </GridLayoutItem>
              </GridLayout>
              <WindowActionsBar layout="start">
                <div className={styles.buttonWrapper}>
                <Button type={"submit"} themeColor={"primary"} 
                        className={!renderProps.allowSubmit ? styles.disabled : styles.enabled}
                        disabled={!renderProps.allowSubmit} 
                        onClick={renderProps.onSubmit}
                >
                  Update
                </Button>
                <Button 
                  onClick={cancelEdit}
                  className={styles.enabled}
                >
                  Cancel
                </Button>

                </div>
              </WindowActionsBar>
            </Window>} {...other} />;
  };

  export default BulkEditForm;